import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-md text-center border border-zinc-800 bg-[#090A0C] p-10 fadeup">
        <XCircle size={44} weight="duotone" className="text-zinc-500 mx-auto mb-6" />
        <h1 data-testid="payment-cancel" className="font-mono-p font-bold uppercase tracking-tight text-xl">
          Checkout Cancelled
        </h1>
        <p className="mt-3 text-sm text-zinc-500">No charge was made. You can pick a plan anytime.</p>
        <Link to="/store" className="inline-block mt-6 font-mono-p text-sm uppercase tracking-widest bg-cyan-400 text-black px-5 py-3 font-bold hover:bg-cyan-300 transition-colors">
          Back to Store
        </Link>
      </div>
    </div>
  );
}
